import { useEffect, useState } from 'react'
import { Modal } from 'components'
import ErrorMessage from 'components/forms/error-message'
import { lang } from 'config'
import _ from 'lodash'
import { Plus } from 'components/icons/outline'
import axios from 'axios'
import { toast } from 'react-hot-toast'
import nProgress from 'nprogress'
import Label from 'components/forms/label'
import InputDate from 'components/forms/input-date'
import moment from 'moment'
import InputAmount from 'components/forms/input-amount'
import { usePage } from 'contexts/page-context'
import Description from 'components/forms/description'
import StockList from './stock-list'
import Input from 'components/forms/input'

const Content = ({ priceData, stockData, onSubmit }) => {
    const { configuration } = usePage()

    const [activeDate, setActiveDate] = useState()
    const [maxRetailPrice, setMaxRetailPrice] = useState()
    const [price, setPrice] = useState()

    const [excluded, setExcluded] = useState([])

    const [errors, setErrors] = useState({})

    useEffect(() => {
        if (priceData) {
            var excludes = []

            priceData.forEach((row) => excludes.push(new Date(row.active_date)))

            setExcluded(excludes)
        }
    }, [priceData])

    useEffect(() => {
        if (configuration('site') === 'go' && stockData.length) {
            setMaxRetailPrice(_.maxBy(stockData, 'maximum_retail_price').maximum_retail_price)
        }
    }, [stockData])

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!nProgress.isStarted()) {
            nProgress.start()

            toast.loading("Loading", {
                id: "submit"
            })

            axios.post(`${process.env.REACT_APP_INVENTORY_API_URL}/product/unit/validate`, {
                type: 'price',
                active_date: activeDate,
                maximum_retail_price: maxRetailPrice,
                price
            }).then((response) => {
                toast.success(response.data.message, {
                    id: "submit"
                })

                onSubmit({
                    active_date: activeDate,
                    maximum_retail_price: maxRetailPrice,
                    price
                })

                nProgress.done()
            }).catch((error) => {
                if (error.response.status === 422) {
                    setErrors(error.response.data.errors)
                }
                toast.error(error.response.data.message, {
                    id: "submit"
                })

                console.log(error.response)

                nProgress.done()
            })
        } else {
            toast.error("Previous action is loading")
        }
    }

    return (
        <div className="mt-8 space-y-8">
            <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <StockList data={stockData ?? []} largeButton={true} />
                    </div>

                    <div>
                        <Label htmlFor="active_date" value="Active Date" />
                        {/* <Input type="date" id="active_date" onChange={(e) => setActiveDate(e.target.value)} value={activeDate} /> */}
                        <InputDate dateFormat="dd/MM/yyyy" excludeDates={excluded} error={errors.active_date} id="active_date" onChange={(value) => setActiveDate(moment(value).format('Y-MM-DD'))} value={Date.parse(activeDate)} selected={Date.parse(activeDate)} />
                        <ErrorMessage error={errors.active_date} />
                    </div>

                    <div></div>

                    <div>
                        <Label htmlFor="max_retail_price" value="Maximum Retail Price" />
                        <InputAmount disabled={configuration('site') === 'go'} onChange={(value) => setMaxRetailPrice(value)} value={parseFloat(maxRetailPrice)} id="max_retail_price" error={errors.maximum_retail_price} />
                        <Description value={configuration('site') === 'go' ? 'Retrieved from max amount of available stock.' : ''} error={errors.maximum_retail_price} />
                    </div>

                    <div>
                        <Label htmlFor="price" value="Price" />
                        <InputAmount onChange={(value) => setPrice(value)} value={parseFloat(price)} id="price" error={errors.price} />
                        <ErrorMessage error={errors.price} />
                    </div>
                </div>
            </div>
            <div className="text-xs">
                <button onClick={handleSubmit} className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90">
                    <span>{lang.save}</span>
                </button>
            </div>
        </div>
    )
}

const Add = ({ priceData, stockData, onSubmit }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSubmit = (data) => {
        onSubmit(data)

        closeModal()
    }

    return (
        <>
            <button type="button" onClick={openModal} className="inline-flex items-center px-4 py-3 space-x-2 transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90">
                <Plus className="w-4 h-4" stroke={1.5} />
                <span>{lang.create}</span>
            </button>
            <Modal isOpen={isOpen} onClose={closeModal} title={`${lang.create} ${lang.data}`} content={<Content priceData={priceData} stockData={stockData} onSubmit={handleSubmit} />} />
        </>
    )
}

export default Add